const LANGUAGES = {
	EN: {
		name: 'English',
		flag: 'gb',
	},
	PL: {
		name: 'Polski',
		flag: 'pl',
	},
	DE: {
		name: 'Deutsch',
		flag: 'de',
	},
	SV: {
		name: 'Svenska',
		flag: 'se',
	},
	NO: {
		name: 'Norsk',
		flag: 'no',
	},
	FR: {
		name: 'Français',
		flag: 'fr',
	},
} as const;

export default LANGUAGES;
